import { WEBSOCKET_URL } from "../constants";

export const usePrinter = (pdfLink: string, siteName: string) => {
  const ws = WebSocketSingleton.getConnection();

  // TODO: update this to remove redundant params once websocket is updated. Moving forward pdfLink will always be present
  const data = {
    message: pdfLink,
    pdfLinkFlag: true,
    productLabel: "Label Printer",
    fitToPrintableArea: siteName === "INHOUSE" ? true : false,
  };

  // Check if the WebSocket is open before sending the message
  if (ws.readyState === WebSocket.OPEN) {
    ws.send(JSON.stringify(data));
  } else {
    // Handle the case where the WebSocket is not connected
    window.open(pdfLink);
  }

  return;
};

class WebSocketSingleton {
  static instance: WebSocketSingleton;
  connection: WebSocket;

  constructor() {
    if (!WebSocketSingleton.instance) {
      this.connection = new WebSocket(WEBSOCKET_URL);
      WebSocketSingleton.instance = this;
    }

    return WebSocketSingleton.instance;
  }

  static getConnection() {
    return WebSocketSingleton.instance.connection;
  }
}

const instance = new WebSocketSingleton();
Object.freeze(instance);

export default instance;
